import call from './index'
//订单列表

export function GyOrderList(data) {
	return call(`admin/order/search`, data, 'get')
}

export function GySpellOrderList(data) {
	return call(`admin/spell/order/search`, data, 'get')
}

//导出订单列表
export function exportOrderList(data) {
	return call(`admin/order/export`, data, 'get')
}

//导出自产自销订单列表
export function exportSpellOrderList(data) {
	return call(`admin/spell/order/export`, data, 'get')
}

//订单备注列表

export function orderRemarkList(id, data) {
	return call(`admin/order/${id}/order_remark/list`, data, 'get')
}

//订单日志列表
export function orderLogList(data) {
	return call(`admin/order/log`, data)
}

//订单备注创建
export function orderRemarkCreate(data) {
	return call(`admin/order_remark/create`, data)
}

//订单详情
export function orderDetailInfo(id) {
	return call(`/admin/order/${id}/detail/get`, null, 'get')
}

//订单详情
export function orderSpellDetailInfo(id) {
	return call(`/admin/spell/order/${id}/detail/get`, null, 'get')
}


//关闭订单
export function closeOrder(id) {
	return call(`admin/order/${id}/close`, { id: id })
}
//物流公司列表
export function expressCompanyList() {
	return call(`admin/express_company/list`, null, 'get')
}

//更新物流信息
export function updateExpress(id, data) {
	return call(`admin/order/${id}/express/update`, data)
}

//追踪物流轨迹
export function expressLogisticsTrace(data) {
	return call(`admin/express_logistics_trace/list`, data, 'get')
}

//订单维权列表
export function safeguardOrderList(data) {
	return call(`admin/order/after/sale/search`, data)
}

//维权列表导出
export function exportOrderAferSale(data) {
	return call(`admin/order/after/sale/export`, data)
}
//维权订单详情
export function afterSaleDetail(data) {
	return call(`admin/order/after/sale/detail`, data)
}

//订单维权备注列表获取
export function afterSaleRemarksList(id) {
	return call(`/admin/order/after/sale/remarks/${id}/list`, null, 'get')
}

//维权订单备注更新
export function afterSaleRemarkInsert(data) {
	return call(`/admin/order/after/sale/remark/insert`, data)
}

//订单维权申请处理
export function handleApplySale(data) {
	return call(`/admin/order/after/sale/handle_apply`, data)
}

//快递鸟配置信息
export function kdBirdConfigGet() {
	return call(`admin/setting/kd_bird_config/get`, null, 'get')
}

//申请维权
export function applyRefundAfterSale(data) {
	return call(`/admin/order/after/sale/order/apply_refund`, data)
}
